// extracted by mini-css-extract-plugin
export default {"form":"nSxYev","detailsStepContainer":"pzWnaB","footerContainer":"YUzHmw"};